import { Anchor, HoverCard, Text } from '@mantine/core';
import { Column, Row } from 'utils/models';
import { useAppContext } from 'context/hooks';
import { TableCheckBox } from './TableCheckbox';
import classes from '../Table.module.css';

interface Props<T> {
  columns: Column<T>[];
  data: T;
  row?: Row<T>;
  rowId: string;
  testId?: string;
  selectable?: boolean;
}

export const TableRow = <T,>({ columns, data, row, rowId, testId = '', selectable }: Props<T>) => {
  const renderItem = (column: Column<T>) => {
    const hideOnClick = column.hideOnClick ? column.hideOnClick(data) : false;
    if (column && column.renderItem && column.onClick && !hideOnClick) {
      return (
        <Anchor c={'var(--mantine-color-turquoise-7)'} onClick={() => column.onClick?.(data)}>
          {column.renderItem(data)}
        </Anchor>
      );
    }

    if (column && column.renderItem) {
      return column.renderItem(data);
    }
    return '';
  };

  const renderClassName = () => (row ? row.renderOverlay(data) : false);

  const { updateTableRowIds, selectedTableRowIds = [] } = useAppContext();

  const handleSelected = () => {
    if (updateTableRowIds) {
      updateTableRowIds(rowId);
    }
  };

  const renderTooltip = () => row?.renderTooltip?.(data);
  const isSelected = selectedTableRowIds.includes(rowId);

  return (
    <HoverCard shadow={'md'} disabled={!renderTooltip()}>
      <HoverCard.Target>
        <tr
          key={rowId}
          data-testid={testId}
          className={renderClassName() ? classes.tableRowOverlay : classes.tableRowDefault}
        >
          {selectable && (
            <td>
              <TableCheckBox onChange={() => handleSelected()} checked={isSelected} />
            </td>
          )}
          {columns.map((column, index) => (
            <td key={index} width={column?.width && `${column.width}%`}>
              {renderItem(column)}
            </td>
          ))}
        </tr>
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <Text size={'sm'}>{renderTooltip()}</Text>
      </HoverCard.Dropdown>
    </HoverCard>
  );
};
